import { Component, OnInit, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { FooterComponent } from "../shared/footer/footer.component";
import { HeaderComponent } from "../shared/header/header.component";
import { FleetTrackerService } from "src/app/fleet-tracker.service";

@Component({
	selector: "app-dashboard",
	templateUrl: "./dashboard.component.html",
	styleUrls: ["./dashboard.component.scss"],
	imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class DashboardComponent implements OnInit {
	private fleettracker = inject(FleetTrackerService);


	ngOnInit() {
		this.fleettracker.Refresh();
	}

}
